import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const RealityCheck = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Reality Check</title>
        <meta
          name="description"
          content="Hur skapar man ett välkomnande för sina kvinnliga anställda? Vi hjälper ert företag göra en 
          nulägesanalys och ge er rätt verktyg för att förbättra er jämställdhetsarbete."
        />
        <meta property="og:title" content="We Exist - Reality Check" />
        <meta
          property="og:description"
          content="Hur skapar man ett välkomnande för sina kvinnliga anställda? Vi hjälper ert företag göra en 
          nulägesanalys och ge er rätt verktyg för att förbättra er jämställdhetsarbete."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}
      <PageHeading title="Reality Check" />
      <ServicePageWrapper>
        <img src="./service-images/reality-check.jpg" alt="möte kontor" />
        <p>
          Första steget i rätt riktning mot att jobba mer jämställt på ert
          företag är att vi tillsammans gör en inventering på var på
          jämställdhetsskalan ert företag ligger till i dagsläget. Vi sitter ner
          och gör en gedigen kartläggning ihop för att få en överblick hur ni i
          dagsläget jobbar med jämställdhet och vad ni har för drömmar och mål.
          Kartläggningen innefattar bland annat insamling av data, intervjuer av
          medarbetare, genomgång av befintlig jämställdhetspolicy samt
          behovsanalys.
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
